export type MinionOutput = {
	minion_id?: string;
	minion_input?: string;
	minion_output?: string;
	minion_extra_info?: string;
};

export type MinionPluginInvocationInfo = {
	searchResults?: string[];
	rankedDocuments?: string[];
	chunkedDocuments?: string[];
};

export type PluginInvocation = {
	plugin_invocation_id?: string;
	plugin_name?: string;
	plugin_invocation_status?: PluginInvocationStatus;
	plugin_description?: string;
	plugin_extra_info?: string;
	plugin_input?: string;
	plugin_output?: string;
	plugin_error_message?: string | null;
};

export type PluginExtraInfo = {
	searchResults?: string[];
	rankedDocuments?: string[];
	chunkedDocuments?: string[];
};

export enum PluginName {
	TEAMWORK = 'teamwork',
	PAGE_SEARCH_PLUGIN = 'Page-Search-Plugin',
	SEARCH = 'search',
	PEOPLE = 'people',
}

export enum PluginInvocationStatus {
	PLUGIN_FINISHED = 'PLUGIN_FINISHED',
	PLUGIN_ERRORED = 'PLUGIN_ERRORED',
}

export type TeamworkTeam = {
	type: string;
	ari?: string;
	name?: string;
	description?: string;
	creator?: string;
	memberCount?: number;
	members: string[];
	teamState?: string;
};

export type TeamworkDocument = {
	type: string;
	ari?: string;
	title?: string;
	url?: string;
	author?: string;
	updated?: string;
};

export type TeamworkOutput = {
	header?: string;
	sections: Array<{
		sectionHeader?: string;
		teams?: TeamworkTeam[];
		documents?: TeamworkDocument[];
	}>;
};

export type PeopleProfile = {
	name?: string;
	picture?: string;
	email?: string;
	timezone?: string;
	locale?: string;
	nickname?: string;
	jobTitle?: string;
	location?: string;
	department?: string;
	organization?: string;
};

export type PeopleEntry = {
	header?: string;
	accountId?: string;
	profile: PeopleProfile;
};

export type PeopleOutput = {
	people: PeopleEntry[];
};

export type PageSearchPage = {
	title?: string;
	url?: string;
	space?: string;
	date?: string;
	author?: string;
	snippet?: string;
};

export type PageSearchOutput = {
	header?: string;
	pages: PageSearchPage[];
};

export type ParsedPluginOutput =
	| { type: 'teamwork'; data: TeamworkOutput }
	| { type: 'people'; data: PeopleOutput }
	| { type: 'pageSearch'; data: PageSearchOutput };

export enum MinionName {
	TEAMWORK_AGENT = 'TeamworkAgent',
	SEARCH = 'search',
}

export type FunctionResultType = {
	pluginInvocationInfo?: {
		name?: string;
		status?: FunctionResultStatus;
		output?: string;
	};
};

export enum FunctionResultStatus {
	SUCCESS = 'SUCCESS',
	ERROR = 'ERROR',
}
